import { render, staticRenderFns } from "./StakewiseApr.vue?vue&type=template&id=428c465e&scoped=true"
import script from "./StakewiseApr.vue?vue&type=script&lang=js"
export * from "./StakewiseApr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428c465e",
  null
  
)

export default component.exports